import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { ReactComponent as ArrowCircleLeftIcon } from '../../../assets/icons/solid/arrow-circle-left.svg';
import emailSuccessImage from '../../../assets/images/email-success.png';
import { TDButton, TDInputText, TDTypography } from '../../../atoms/TDUILib';
import AuthHeader from '../components/AuthHeader/AuthHeader';
import './RecoverPasswordPage.scss';
import useRecoverPassword from './useRecoverPassword';
const RecoverPasswordPage = () => {
  const { t, i18n } = useTranslation();
  const navigate = useNavigate();
  const [hasError, setHasError] = useState(false);
  const [email, setEmail] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [emailSent, setEmailSent] = useState(false);
  const { sendRecoverPasswordEmail } = useRecoverPassword();

  const handleSendRecoverPasswordEmail = async () => {
    setIsLoading(true);
    setHasError(false);

    const response = await sendRecoverPasswordEmail({
      email,
      lang: i18n.language
    });

    if (response?.status === 'error' || response?.errorCode) {
      setHasError(true);
      setEmailSent(false);
    } else {
      setEmailSent(true);
    }

    setIsLoading(false);
  };

  return (
    <div className='recover-page__container'>
      {!emailSent ? (
        <>
          <AuthHeader
            title={t('password_recovery_title')}
            subTitle={t('password_recovery_subtitle')}
            subTitleVariant={'light'}
            className='recover-page__header'
          />
          <div className='recover-page__email-form'>
            <div className='recover-page__content'>
              <TDInputText
                fullWidth
                disabled={isLoading}
                type='text'
                label={t('email')}
                placeholder={t('password_recovery_email_placeholder')}
                value={email}
                inputProps={{ 'data-testid': 'recover-email-input' }}
                onChange={({ target: { value } }) => {
                  setEmail(value);
                }}
                hasError={hasError}
                errorText={t('password_recovery_error_user_not_found')}
              />

              <TDButton
                color='primary'
                variant='solid'
                fullWidth
                onClick={handleSendRecoverPasswordEmail}
                disabled={isLoading}
                data-testid='recover-password-button'
              >
                {t('password_recovery_send_button')}
              </TDButton>
            </div>
            <div className='recover-page__email-form-footer'>
              <TDButton
                color='primary'
                variant='text'
                size='sm'
                fullWidth
                onClick={() => navigate('/login')}
                icon={<ArrowCircleLeftIcon />}
                iconPosition='left'
              >
                {t('password_recovery_back_to_home')}
              </TDButton>
            </div>
          </div>
        </>
      ) : (
        <>
          <AuthHeader className='recover-page__header' />
          <div className='recover-page__email-success'>
            <div className='recover-page__content'>
              <div className='recover-page__email-success-title'>
                <TDTypography as='div' variant='body-xl' fontWeight='semibold'>
                  {t('password_recovery_mail_success_title')}
                </TDTypography>
              </div>
              <img
                src={emailSuccessImage}
                alt='Email sent successfully'
                className='recover-page__success-image'
              />
              <div className='recover-page__email-success-text'>
                <TDTypography as='div' variant='body-m' fontWeight='medium'>
                  {t('password_recovery_mail_success_text')}
                </TDTypography>
              </div>
            </div>
            <div className='recover-page__email-success-footer'>
              <TDTypography as='div' variant='body-s' fontWeight='medium'>
                {t('password_recovery_no_email')}
              </TDTypography>
              <TDButton
                color='primary'
                variant='text'
                size='sm'
                onClick={handleSendRecoverPasswordEmail}
              >
                {t('password_recovery_resend')}
              </TDButton>
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default RecoverPasswordPage;
